import type { PropsWithChildren } from "react";
import { Navigate, Outlet, Routes } from "react-router-dom";

import { PORTAL_USER_TYPE } from "@/app/models";
import { usePortalUserStore } from "@/app/stores";
import { useLanguageFromParams } from "@/shared/hooks";
import { useAuthStore } from "@/shared/stores";
import { AnimatedBackground, Layout } from "@/shared/ui";
import { ROUTES } from "../constants";

export const RequireLoggedOut = ({ children }: PropsWithChildren) => {
  useLanguageFromParams();

  const isLoggedOut = useAuthStore((state) => !state.token);
  const portalUser = usePortalUserStore((state) => state.portalUser);
  if (!isLoggedOut) {
    switch (portalUser?.type) {
      case PORTAL_USER_TYPE.PATIENT:
        return <Navigate replace to={ROUTES.HOME} />;
      case PORTAL_USER_TYPE.COACHING:
      case PORTAL_USER_TYPE.ADMIN:
        return <Navigate replace to={ROUTES.COACHING.OVERVIEW} />;
    }
  }

  return <>{children}</>;
};

export const GuestRoutesWrapper = ({ children }: PropsWithChildren) => {
  return (
    <RequireLoggedOut>
      <main className="flex h-dvh bg-white">
        <AnimatedBackground theme="light" />

        <Layout.Content size="sm">
          <Routes>{children}</Routes>
          <Outlet />
        </Layout.Content>
      </main>
    </RequireLoggedOut>
  );
};
